import React, { useEffect, createElement } from 'react';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { PromiseSection } from './components/PromiseSection';
import { ProofSection } from './components/ProofSection';
import { CasesCarousel } from './components/CasesCarousel';
import { OfferSection } from './components/OfferSection';
import { UrgencySection } from './components/UrgencySection';
import { FloatingNotifications } from './components/FloatingNotifications';
export function App() {
  useEffect(() => {
    // Meta Pixel
    if (!(window as any).fbq) {
      const n = function (...args: any[]) {
        ;
        (n as any).callMethod ? (n as any).callMethod.apply(n, args) : (n as any).queue.push(args);
      };
      (n as any).push = n;
      (n as any).loaded = true;
      (n as any).version = '2.0';
      (n as any).queue = [];
      (window as any).fbq = n;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', '2411207615977952');
    (window as any).fbq('track', 'PageView');
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2411207615977952&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-matte font-sans text-matte selection:bg-gold selection:text-matte" data-id="element-0">
      <HookSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <ProofSection data-id="element-4" />
      <CasesCarousel data-id="element-5" />
      <OfferSection data-id="element-6" />
      <UrgencySection data-id="element-7" />
      <FloatingNotifications data-id="element-8" />
    </div>;
}